import React, { ReactElement } from "react";
import { ensure } from "sprint-common-web";

import { LanguageDetailsInfo } from "../../../../common/components/details-info/LanguageDetailsInfo";
import { VideoDetailsInfo } from "../../../../common/components/details-info/VideoDetailsInfo";
import { DynamicSubtitleType } from "../../../../common/types/DynamicSubtitleType";
import { RecordType } from "../../../../common/types/RecordType";
import { FileRecordListingItem } from "../../listing/types/FileRecordListingItem";

export const renderFileRecordDetails = (item?: FileRecordListingItem): ReactElement | null => {
    ensure(item);

    switch (item.recordType) {
        case RecordType.Video:
            return <VideoDetailsInfo key="video" subtitle={item.subtitle} aspectRatio={item.aspectRatio} />;
        case RecordType.Audio:
            return <LanguageDetailsInfo key="audio" language={item.soundtracks[0]} />;
        case RecordType.Subtitle:
            return (
                <LanguageDetailsInfo
                    key="subtitle"
                    language={item.subtitle}
                    subtitleType={item.subtitleType ? DynamicSubtitleType[item.subtitleType] : undefined}
                />
            );
        default:
            return <></>;
    }
};
